import * as actions from "../../utils/Actions";
import { notUndefinedAndNull } from "../../utils/Validation";

    const initialState = {
      showPageLoader: false,
      paymentResponse:null,
      paymentInitiateResponse:null,
      paymentLinkDetails:null,
      verifyLinkResponse:null
      
    };
  
    export default function PaymentReducer(state = initialState, action) {
      if (typeof state === "undefined") {
        return state;
      }
    
      switch (action.type) {

        case actions.RESET_PAYMENT_STATUS:
            return {
                ...state,
                paymentResponse: null,
                paymentInitiateResponse:null
            }


        // form structure save ::
        case actions.pending(actions.GET_PAYMENT_STATUS):
          return {
            ...state,
            showPageLoader: true,
            paymentResponse:null
          };
        case actions.fulfilled(actions.GET_PAYMENT_STATUS):
          return {
            ...state,
            showPageLoader: false,
            paymentResponse: action.payload.data,
        };

        case actions.rejected(actions.GET_PAYMENT_STATUS):
          return {
            ...state,
            showPageLoader: false,
          };


        case actions.pending(actions.PAYMENT_INITIATE):
          return {
            ...state,
            showPageLoader: true,
            paymentInitiateResponse:null
          };
        case actions.fulfilled(actions.PAYMENT_INITIATE):
          return {
            ...state,
            showPageLoader: false,
            paymentInitiateResponse: action.payload,
        };

        case actions.rejected(actions.PAYMENT_INITIATE):
          return {
            ...state,
            showPageLoader: false,
          };       
          
        
        case actions.pending(actions.PAYMENT_LINK_DETAILS):
          return {
            ...state,
            showPageLoader: true,
            paymentLinkDetails:null
          };
        case actions.fulfilled(actions.PAYMENT_LINK_DETAILS):
          return {
            ...state,
            showPageLoader: false,
            paymentLinkDetails: (notUndefinedAndNull(action.payload.data) && notUndefinedAndNull(action.payload.data.token))?action.payload:action.payload.data,
        };

        case actions.rejected(actions.PAYMENT_LINK_DETAILS):
          return {
            ...state,
            showPageLoader: false,
            paymentLinkDetails:action.payload.data
          };  
          
        case actions.pending(actions.VERIFY_LINK_TOKEN):
          return {
            ...state,
            showPageLoader: true,
            verifyLinkResponse:null
          };
        case actions.fulfilled(actions.VERIFY_LINK_TOKEN):
          return {
            ...state,
            showPageLoader: false,
            verifyLinkResponse: action.payload,
          };

        case actions.rejected(actions.VERIFY_LINK_TOKEN):
          return {
            ...state,
            showPageLoader: false,
          }; 
          
          
          
          
        default:
            return { ...state };
        }
    }